import { render, staticRenderFns } from "./exam-name.vue?vue&type=template&id=02b49faa&scoped=true"
import script from "./exam-name.vue?vue&type=script&lang=ts"
export * from "./exam-name.vue?vue&type=script&lang=ts"
import style0 from "./exam-name.vue?vue&type=style&index=0&id=02b49faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b49faa",
  null
  
)

export default component.exports